import { AdminSupportService } from "../../../services/admin-support.service.js";

export const SupportTab = async (container) => {
    // 1. Initial Layout
    container.innerHTML = `
        <div class="flex flex-col gap-6">
            <div class="flex justified-between items-center">
                <h2 class="text-xl font-bold text-gray-800">1:1 문의 관리</h2>
                <button id="btn-refresh-support" class="bg-white hover:bg-gray-50 border border-gray-300 text-gray-700 px-3 py-1.5 rounded-lg text-sm font-bold flex items-center gap-2 shadow-sm transition-colors ml-auto">
                    <span class="material-symbols-outlined text-sm">refresh</span> 새로고침
                </button>
            </div>

            <!-- Ticket List -->
            <div class="bg-white shadow sm:rounded-lg border border-gray-200 overflow-hidden">
                <table class="min-w-full divide-y divide-gray-200">
                    <thead class="bg-gray-50">
                        <tr>
                            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">상태</th>
                            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-1/2">문의 내용</th>
                            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">사용자 (UID)</th>
                            <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">날짜</th>
                            <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">관리</th>
                        </tr>
                    </thead>
                    <tbody id="support-table-body" class="bg-white divide-y divide-gray-200">
                        <tr><td colspan="5" class="text-center py-10 text-gray-400">데이터를 불러오는 중...</td></tr>
                    </tbody>
                </table>
            </div>
        </div>
    `;

    // 2. Load Data
    const loadData = async () => {
        const tbody = container.querySelector('#support-table-body');
        tbody.innerHTML = '<tr><td colspan="5" class="text-center py-10 text-gray-400">로딩 중...</td></tr>';

        try {
            const tickets = await AdminSupportService.getAllTickets();

            if (tickets.length === 0) {
                tbody.innerHTML = '<tr><td colspan="5" class="text-center py-10 text-gray-400">접수된 1:1 문의가 없습니다.</td></tr>';
                return;
            }

            tbody.innerHTML = '';
            tickets.forEach(ticket => {
                const tr = document.createElement('tr');
                tr.className = "hover:bg-gray-50 transition-colors";

                const isReplied = !!ticket.replyContent;
                const statusBadge = isReplied
                    ? `<span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">답변완료</span>`
                    : `<span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800">대기중</span>`;

                tr.innerHTML = `
                    <td class="px-6 py-4 whitespace-nowrap">
                        ${statusBadge}
                    </td>
                    <td class="px-6 py-4">
                        <div class="text-sm text-gray-900 break-words max-w-xl">${ticket.content}</div>
                        ${isReplied ? `<div class="text-xs text-indigo-600 mt-1 font-bold">↳ 답변내용: ${ticket.replyContent}</div>` : ''}
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-xs text-gray-500 font-mono">
                        ${ticket.userId}
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-right text-xs text-gray-500">
                        ${ticket.createdAt.toLocaleString()}
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                        <button class="text-indigo-600 hover:text-indigo-900 btn-reply" data-id="${ticket.id}">
                            ${isReplied ? '수정' : '답변하기'}
                        </button>
                    </td>
                `;
                tbody.appendChild(tr);
            });

            // Bind Events
            tbody.querySelectorAll('.btn-reply').forEach(btn => {
                btn.onclick = async () => {
                    const id = btn.dataset.id;
                    const ticket = tickets.find(t => t.id === id);
                    const currentReply = ticket.replyContent || "";

                    const reply = await window.Modal.prompt("답변 내용을 입력하세요:", currentReply, "1:1 답변");
                    if (reply === null) return; // Cancelled

                    if (!reply.trim()) return alert("내용을 입력해주세요.");

                    await AdminSupportService.replyToTicket(id, reply);
                    window.Modal.toast("답변이 등록되었습니다.");
                    loadData(); // Reload
                };
            });

        } catch (e) {
            console.error(e);
            tbody.innerHTML = `<tr><td colspan="5" class="text-center py-10 text-red-500">Error: ${e.message}</td></tr>`;
        }
    };

    // Helper
    container.querySelector('#btn-refresh-support').onclick = loadData;

    // Start
    loadData();
};
